/*

Required Data – Contact Number is used to differentiate between multiple contacts in Mexico and/or Canada
Optional Data – Government Agency
Required Data – Contact
Optional Data – Government Office/Title
Required Data – Address 1
Optional Data – Address 2
Required Data – City
Required Data – State is a drop-down menu with MX and Canadian provinces
Required Data – Zip Code

*/


import { useState, useRef } from "react"
import ReactDOM from "react-dom";
import { canadianProvinces } from "../../utils/countryOptions";
import { mexicanStates } from "../../utils/countryOptions";

export default function Helpcontact(){

    const defaults = {
        "contactNumber" : "",
        "agency"        : "",
        "contact"       : "",
        "officeTitle"   : "",
        "address1"      : "",
        "address2"      : "",
        "city"          : "",
        "state"         : "",
        "zip"           : "",
        "country"       : ""
    }

    const [ formData, setFormData ] = useState(defaults);
    const stateRef = useRef(null);

    const handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        if(name === "country"){
            setFormData((formData) => ({ ...formData, "state": "" }))
        }
        setFormData((formData) => ({ ...formData, [name]: value }));
    }

    const handleCancel = () => {
        return
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(formData.contactNumber === ""){ return }
        if(formData.contact === "") { return }
        if(formData.address1 === "") { return }
        if(formData.city === "") { return }
        if(formData.state === "") { return }
        if(formData.zip === "") { return }
        if(formData.country === "") { return }

        alert("Success: "+ JSON.stringify(formData))
    }

    const Cn = () => {
        return(
            <div>
             <label className="form-label"><b>Provence</b></label>
                <select className="form-control form-select"
                    value={formData.state}
                    name="state"
                    onChange={(e) => handleChange(e)}>
                        {canadianProvinces.map((opt) => (
                        <option key={opt.code} value={opt.code} title={opt.label}>
                            {opt.code} - {opt.label}
                        </option>
                        ))}
                    </select>
            </div>
        )
    }

    const Mx = () => {
        return(
            <div>
             <label className="form-label"><b>state</b></label>
                <select className="form-control form-select"
                    value={formData.state}
                    name="state"
                    onChange={(e) => handleChange(e)}>
                        {mexicanStates.map((opt) => (
                        <option key={opt.code} value={opt.code} title={opt.label}>
                            {opt.code} - {opt.label}
                        </option>
                        ))}
                    </select>
            </div>
        )
    }

    if(formData.country === "cn"){
            try {    
              ReactDOM.render(<Cn />,
                stateRef.current); 
              } catch(err){
                alert(err)
              }
    }

    if(formData.country === "mx"){
            try {    
              ReactDOM.render(<Mx />,
                stateRef.current); 
              } catch(err){
                alert(err)
              }
    }


    return(
        <div className="App"><h1>Foreign Contact Update</h1>
            <div id="table">
                <form  className="needs-validation was-validated"
                    id="Index-form"
                    onSubmit={(e) => handleSubmit(e)}>
                        <div className="row">
                            <div className="col">
                                  <label className="form-label"><b>Contact Number</b></label>
                                  <input type="text" className="form-control" name="contactNumber" 
                                  value={formData.contactNumber}
                                  onChange={(e) =>handleChange(e)}
                                  maxLength={18} required />
                              </div>
                                <div className="col">
                                    <label className="form-label"><b>Government Agency</b></label>
                                    <input type="text" className="form-control" name="agency" 
                                    value={formData.agency}
                                    onChange={(e) =>handleChange(e)}
                                    maxLength={18}/>
                                </div>
                                <div className="col">
                                  <label className="form-label"><b>Contact</b></label>
                                  <input type="text" className="form-control" name="contact" 
                                  value={formData.contact}
                                  onChange={(e) =>handleChange(e)}
                                  maxLength={18} required />
                                </div>
                                <div className="col">
                                    <label className="form-label"><b>Government Office / Title</b></label>
                                    <input type="text" className="form-control" name="officeTitle" 
                                    value={formData.officeTitle}
                                    onChange={(e) =>handleChange(e)}
                                    maxLength={18}/>
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label"><b>Country</b></label>
                                  <select className="form-control form-select"
                                      name="country"
                                      value={formData.country}
                                      onChange={(e) => handleChange(e)}
                                  >
                                      <option value="">- Country -</option>
                                      <option value="cn">Canada</option>
                                      <option value="mx">Mexico</option>
                                  </select>
                              </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                  <label className="form-label"><b>Street Address 1</b></label>
                                  <input type="text" className="form-control" name="address1" 
                                  value={formData.address1}
                                  onChange={(e) =>handleChange(e)}
                                  maxLength={18} required />
                            </div>
                            <div className="col">
                                  <label className="form-label"><b>Sreet Address 2</b></label>
                                  <input type="text" className="form-control" name="address2" 
                                  value={formData.address2}
                                  onChange={(e) =>handleChange(e)}
                                  maxLength={18}/>
                            </div>
                            <div className="col">
                                  <label className="form-label"><b>City</b></label>
                                  <input type="text" className="form-control" name="city" 
                                  value={formData.city}
                                  onChange={(e) =>handleChange(e)}
                                  maxLength={18} required />
                            </div>
                            <div className="col">
                                  <label className="form-label"><b>Zip Code</b></label>
                                  <input type="text" className="form-control" name="zip" 
                                  value={formData.zip}
                                  onChange={(e) =>handleChange(e)}
                                  maxLength={18} required />
                              </div>
                               <div className="col-md-3" ref={stateRef}>
                              </div>
                        </div>
                        

                </form>
            </div>   
                   <button type="submit" className="btn btn-primary mt-3"
                    onClick={(e) => handleSubmit(e)}>
                    Enter
                </button>
                <button type="button" onClick={(e) => handleCancel(e)} className="btn btn-secondary mt-3 ms-2">
                    Cancel
                </button>
        </div>
    )
    
}